__turbopack_context__.v({
  "formSubmit": "form-submit-module-scss-module__HLFwJq__formSubmit",
});
